module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/lion-btn-audio-portuguesse.da94f04b.png";